/* eslint-disable */
const getters = {
  getFilterGroups(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
